import { render } from "./Ecrire.vue?vue&type=template&id=6b4e61e0&scoped=true"
import script from "./Ecrire.vue?vue&type=script&lang=js"
export * from "./Ecrire.vue?vue&type=script&lang=js"

import "./Ecrire.vue?vue&type=style&index=0&id=6b4e61e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e61e0"]])

export default __exports__